const PREFIX = 'ACCOUNT_CONNECTOR';
export default {
    USERNAME_CHANGED: `${PREFIX}:USERNAME_CHANGED`,
    PASSWORD_CHANGED: `${PREFIX}:PASSWORD_CHANGED`,
    PROOF_OF_OWNERSHIP_TYPE_CHANGED: `${PREFIX}:PROOF_OF_OWNERSHIP_TYPE_CHANGED`,
    PROOF_OF_OWNERSHIP_VALUE_CHANGED: `${PREFIX}:PROOF_OF_OWNERSHIP_VALUE_CHANGED`,
    SUBMIT: `${PREFIX}:SUBMIT`,
    SUBMIT_IN_PROGRESS: `${PREFIX}:SUBMIT_IN_PROGRESS`,
    SUBMIT_COMPLETED: `${PREFIX}:SUBMIT_COMPLETED`,
    AUTHORIZATION_COMPLETE: `${PREFIX}:AUTHORIZATION_COMPLETE`,
    AUTHORIZATION_FAILED: `${PREFIX}:AUTHORIZATION_FAILED`,
    NAVIGATE_BACK: `${PREFIX}:NAVIGATE_BACK`,
    SHOW_RADIO_MOBILE: `${PREFIX}:SHOW_RADIO_MOBILE`
};


// WEBPACK FOOTER //
// ./src/modules/account-connector/actionTypes.js